export default __webpack_public_path__ + "static/media/english-to-vietnamese-screenshot-01.81064971.png";